import { Navigate } from 'react-router-dom';

import './session-page.scss';

import { useIsCustomer } from '~modules/auth/model';
import { ActiveSession } from '~pages/session/active/ActiveSession.tsx';
import { ScanCode } from '~pages/session/scan-code/ScanCodePage.tsx';
import { useJournal } from '~pages/session/use-journal.ts';
import { routerKeys } from '~shared/router';
import { Preloader } from '~shared/ui';

import { IncognitoBlocked } from './incognito/IncognitoBlocked';
import { PhotoScreen } from './photo/PhotoScreen';

export function SessionPage() {
	const isCustomer = useIsCustomer();
	const {
		isPending,
		journal,
		create,
		setPhoto,
		coordinates,
		getPosition,
		deviceInfo,
		isDeviceChecked,
		isIncognitoBlocked,
	} = useJournal();

	if (!isCustomer) return <Navigate to={routerKeys.denied()} />;

	// Сканер не показываем, пока устройство не проверено - иначе в приватном режиме
	// успеет пройти отметка до появления блокировки
	if (isPending || !isDeviceChecked)
		return (
			<div className="session-page">
				<Preloader />
			</div>
		);

	if (deviceInfo?.is_incognito && isIncognitoBlocked)
		return (
			<div className="session-page">
				<IncognitoBlocked />
			</div>
		);

	if (!journal)
		return (
			<div className="session-page">
				<ScanCode
					onScan={create}
					coords={coordinates}
					getPosition={getPosition}
					isIncognito={deviceInfo?.is_incognito}
				/>
			</div>
		);

	if (!journal.id) {
		return (
			<div className="session-page">
				<PhotoScreen onCreate={setPhoto} />
			</div>
		);
	}

	return (
		<div className="session-page">
			<ActiveSession journal={journal} />
		</div>
	);
}
